<template>
  <div class="box" v-loading="loading">
    <div
      v-for="item in tableData"
      :key="item.contractNo"
      style="page-break-after: always; margin-bottom: 30px"
    >
      <table
        style="width: 100%; border-color: #000; text-align: center"
        border="1"
        cellspacing="0"
        cellpadding="0"
      >
        <tr>
          <th colspan="9">收费结算明细表</th>
        </tr>
        <tr>
          <th>公司</th>
          <td width="16%">{{ item.companyName }}</td>
          <th>部门</th>
          <td colspan="2">{{ item.departmentName }}</td>
          <td colspan="2">{{ item.dateTime }}</td>
          <th>单位</th>
          <td>（元）</td>
        </tr>
        <tr>
          <td rowspan="2">月份</td>
          <td rowspan="2">业主名称</td>
          <td rowspan="2">统计项目</td>
          <td rowspan="2">上月末未收款</td>
          <td colspan="2">应收款</td>
          <td colspan="2">已收款</td>
          <td colspan="2" rowspan="2">月末未收款</td>
        </tr>
        <tr>
          <td>本月数</td>
          <td>累计数</td>
          <td>本月数</td>
          <td>累计数</td>
        </tr>

        <tr v-for="(i, index) in item.tableList" :key="index">
          <td>{{ capture(i.accountPeriod) }}</td>
          <td>{{ i.customerName }}</td>
          <td>{{ i.expenseTypeName }}</td>
          <td>{{ i.beginPeriodNotReceived }}</td>
          <td>{{ i.currentReceivables }}</td>
          <td>{{ i.totalReceivables }}</td>
          <td>{{ i.currentReceived }}</td>
          <td>{{ i.totalReceived }}</td>
          <td>{{ i.finalNotReceived }}</td>
        </tr>
        <tr>
          <th colspan="3">合计</th>
          <td>{{ item.beginPeriodNotReceivedTotal }}</td>
          <td>{{ item.currentReceivablesTotal }}</td>
          <td>{{ item.totalReceivablesTotal }}</td>
          <td>{{ item.currentReceivedTotal }}</td>
          <td>{{ item.totalReceivedTotal }}</td>
          <td>{{ item.finalNotReceivedTotal }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  import ReportMixin from './mixins/reportMixin';
  export default {
    mixins: [ReportMixin],
    data() {
      return {
        tableData: [],
        loading: true,
      };
    },
    created() {
      let params = this.$route.query;
      this.printList(params);
    },
    methods: {
      capture(e) {
        let str1 = e.substring(e.indexOf('-') + 1);
        return str1;
      },
      async printList(objData) {
        let params = JSON.parse(objData.params);
        this.loading = true;
        let list = params.list || [];
        list.forEach((item) => {
          let arr = [];
          arr.push(item);
          let tableList = this.tableStructure(arr);
          var beginPeriodNotReceivedTotal = 0,
            currentReceivablesTotal = 0,
            totalReceivablesTotal = 0,
            currentReceivedTotal = 0,
            totalReceivedTotal = 0,
            finalNotReceivedTotal = 0,
            dateTimeDays = null;
          tableList.forEach((i) => {
            dateTimeDays = i.accountPeriod.split('-');
            beginPeriodNotReceivedTotal += i.beginPeriodNotReceived;
            currentReceivablesTotal += i.currentReceivables;
            totalReceivablesTotal += i.totalReceivables;
            currentReceivedTotal += i.currentReceived;
            totalReceivedTotal += i.totalReceived;
            finalNotReceivedTotal += i.finalNotReceived;
          });
          let obj = {
            dateTime: dateTimeDays[0] + '年度' + dateTimeDays[1] + '月份',
            beginPeriodNotReceivedTotal: beginPeriodNotReceivedTotal,
            currentReceivablesTotal: currentReceivablesTotal,
            totalReceivablesTotal: totalReceivablesTotal,
            currentReceivedTotal: currentReceivedTotal,
            totalReceivedTotal: totalReceivedTotal,
            finalNotReceivedTotal: finalNotReceivedTotal,
            tableList: tableList,
            companyName: params.companyName,
            departmentName: params.departmentName,
          };
          this.tableData.push(obj);
        });
        setTimeout(() => {
          this.print();
        }, 100);
        this.loading = false;
      },
      print() {
        window.print();
        window.close();
      },
    },
  };
</script>
<style>
  body {
    height: auto;
  }
</style>

<style scoped>
  @media print {
    @page {
      /* size: landscape; */
      margin: 10px;
    }
  }
</style>
